import Entity from "../templates/entity.js";
import setChiclet from "../helpers/chiclet.js";
import createId from "../helpers/generateId.js";

const locales = instantsearch.connectors.connectRefinementList(
	(
		{ widgetParams, canRefine, items, createURL, refine, helper,
		searchForItems, isFromSearch },
		isFirstRender
	) => {
		if ( ! brookingsAlgoliaFeedOptions.facets.includes('locales') ) {
			return;
		}

		// check if items contain only one value, 
		if ( items.length === 1 ) {
			// hide #languageFacetsContainer
			document.querySelector('#languageFacetsContainer').classList.remove('active');
			return false;
		}

		const tmTerms = JSON.parse(brookingsAlgolia.locales);

		const orderdTerms = {};

		items.forEach((item) => {
			const term = tmTerms.find((term) => term.code === item.value);
			item.label = term.name;
			orderdTerms[item.value] = item;
		} );

		items = Object.values(orderdTerms);

		const container = document.getElementById('languageFacets');

		if (isFirstRender) {
			document.querySelector('#languageFacetsContainer').classList.add('active');

			container.addEventListener("click", ({ target }) => {
				const input = target.closest(
					'input[type="checkbox"]'
				);

				if (input) {
					refine(input.value);
				}
			});

			container.addEventListener("input", ({ target }) => {
				const isSearchInput =
					target.nodeName === "INPUT" &&
					target.type === "search";

				if (isSearchInput) {
					searchForItems(target.value);
				}
			});

		} else {
			if ( items.length > 0 ) {
				items.forEach( (item) => {
					setChiclet(item,widgetParams.attribute,refine);
				});
			}
		}

		container.innerHTML =
			Object.values(orderdTerms).map(
				({
					value,
					id,
					isRefined,
					label,
					highlighted,
					count,
					children,
				}) => Entity({
					value,
					id,
					isRefined,
					label,
					highlighted,
					count,
					children,
					'type' : 'locale'
				})
			)
			.join("");
	}
);

export default locales